export default __webpack_public_path__ + "static/media/WGIF_Site_Logo.16517c05.png";